import Dialog from "dialog";
import template from "../html/dialog-config-ups.html";
import css from "../css/dialog-config-ups.css";

class ConfigUPSDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-ups", ConfigUPSDialog);
  }
  constructor() {
    super();

    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

    this.onupdatedevices_handler({detail: application.devices});

    this.show();
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.ups.id;
    this.textboxDeviceStatus.value = devices.ups.status;
    this.textboxUPSPercentage.value = devices.ups.battery_percentage;
    this.textboxUPSVoltage.value = devices.ups.battery_voltage;
    this.textboxPowerMode.value = devices.ups.power_mode;
    this.textboxNTCTemperature.value = devices.ups.ntc_temperature;
    this.textboxTO92Temperature.value = devices.ups.to92_temperature;
    this.textboxSystemVoltage.value = devices.ups.system_voltage;
    this.textboxExternalVoltage.value = devices.ups.external_voltage;
  }
  buttonClose_click(event) {
    this.close();
  }
  close() {
    super.close();
  }
}

ConfigUPSDialog.constructor();

export default ConfigUPSDialog;